import reducer from './reports.reducer';
import * as constant from './reports.constant';
import * as action from './reports.action';
import * as selector from './reports.selector';
import saga from './reports.saga';
import initialState from './reports.initialState';

export default {
  reducer,
  action,
  constant,
  selector,
  name: constant.NAME,
  saga,
  initialState,
};
